export default "__VITE_ASSET__676c071b__"